import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return ((parts[0]![0] ?? "") + (parts.length > 1 ? (parts.at(-1)![0] ?? "") : "")).toUpperCase();
}

export function UserAvatar({
  name,
  picture,
  size = "sm",
}: {
  name: string;
  email?: string;
  picture?: string | null;
  size?: "sm" | "md" | "lg";
}) {
  return (
    <Avatar className={cn(size === "sm" ? "size-6" : size === "md" ? "size-8" : "size-12")}>
      {picture && <AvatarImage src={picture} alt="" referrerPolicy="no-referrer" />}
      <AvatarFallback className="text-[10px] font-medium">{initials(name)}</AvatarFallback>
    </Avatar>
  );
}
